const Invoice = () => import(/* webpackPrefetch: true */ '@/views/private/invoice/Index.vue')

const routes = [
  {
    path: "/invoice",
    name: "invoice",
    component: Invoice,
    meta: {
      title: "Tagihan"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})